import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import Alert from "../material/alert/Alert";
import Router from "../router/Router";
import React, {useEffect, useState} from "react";
import isNull from "../mixin/isNull";
import database from "../database/database";
import useEventDispatcher from "../use/useEventDispatcher";
import "../sentry";

export default function () {
    const eventDispatcher = useEventDispatcher();
    const [mode, setMode] = useState(!isNull(database.read(database.TABLE_THEME, "dark")) ? database.read(database.TABLE_THEME, "dark") : "light");
    const [theme, setTheme] = useState(null);

    useEffect(() => {
        eventDispatcher.subscribe("toggle-mode", handleToggle);

        return () => eventDispatcher.unsubscribe("toggle-mode", handleToggle);
    }, []);

    useEffect(() => {
        database.write(database.TABLE_THEME, "dark", mode);

        setTheme(createTheme({
            palette: {
                mode: mode
            },
            components: {
                MuiUseMediaQuery: {
                    defaultProps: {
                        noSsr: true,
                    },
                },
            }
        }));
    }, [mode]);

    const handleToggle = e => {
        setMode(e.data.mode);
    }

    if (isNull(theme)) return null;

    return (
        <ThemeProvider theme={theme}>
            <span data-test={`theme-${mode}`}/>
            <CssBaseline/>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                <Alert/>
                <Router/>
            </LocalizationProvider>
        </ThemeProvider>
    );
}